import { useState } from "react";

// Small dialog to choose the initial/authorized Kanban column before sending.
export default function ColumnPicker({ columns, title = "Enviar ao Kanban", count, onPick, onClose }) {
  const opts = (columns || []).filter((c) => c.id !== "blocked");
  const [col, setCol] = useState(opts[0]?.id || "");
  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/40 grid place-items-center p-4" onClick={onClose} data-testid="column-picker">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl border border-slate-200 shadow-xl w-full max-w-sm p-6 space-y-4">
        <h3 className="font-heading text-lg font-semibold">{title}</h3>
        {count != null && <p className="text-sm text-slate-500">{count} tarefa(s) selecionada(s).</p>}
        <select value={col} onChange={(e) => setCol(e.target.value)} data-testid="column-picker-select" className="prop-select">
          {opts.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="h-9 px-4 rounded-lg border border-slate-200 text-sm">Cancelar</button>
          <button onClick={() => onPick(col)} disabled={!col} data-testid="column-picker-confirm" className="h-9 px-4 rounded-lg bg-slate-900 text-white text-sm font-medium disabled:opacity-50">Enviar</button>
        </div>
      </div>
    </div>
  );
}
